import React from "react";
import { Spin } from "antd";

import config from "../../config";
import { API } from "utils/api";
import { Get } from "utils/request";
import {
  getSsoToken,
  isSsoConfigured,
  pickTokenFromUrl,
  redirectToSsoLogin,
  setAdminInfo,
  setSsoToken,
  takeReturnPath
} from "utils/sso";

import { StyledLoginPage } from "./style";

class LoginPage extends React.Component {
  state = {
    tip: "正在跳转统一认证中心..."
  };

  componentDidMount() {
    if (!isSsoConfigured()) {
      this.setState({
        tip: "未配置认证中心地址（REACT_APP_SSO_URL），请检查 .env 配置"
      });
      return;
    }
    
    const incomingToken = pickTokenFromUrl();
    const token = incomingToken || getSsoToken();
    if (!token) {
      this.redirect();
      return;
    }

    setSsoToken(token);
    this.setState({ tip: "正在校验登录状态..." });
    this.verify();
  }

  verify = () => {
    Get(API.CHECK_LOGIN)
      .then((user) => {
        setAdminInfo(user);
        // 回到进入登录前的页面；没有记录就回首页
        const backPath = takeReturnPath();
        window.location.replace(backPath || "/");
      })
      .catch(() => {
        // 令牌无效或认证中心不可用，重新走一次登录
        this.redirect();
      });
  };

  redirect = () => {
    this.setState({ tip: "正在跳转统一认证中心..." });
    redirectToSsoLogin();
  };

  render() {
    return (
      <StyledLoginPage>
        <div className="title">{config.title}</div>
        <div className="state">{config.en_title} System</div>
        <Spin size="large" />
        <div className="tip">{this.state.tip}</div>
      </StyledLoginPage>
    );
  }
}

export default LoginPage;
